
import phoneIcon from "../assets/images/icons/phone.svg";
import mapIcon from "../assets/images/icons/maps.svg";

const Footer = () => {
    return(
   
      <div className="cassandra-footer">
            <div className="container">
              <div className="footer-content">
                <div className="top-data">
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <h4 className="label">الجوال</h4>
                            <p className="data md-txt"><img className="img-fluid"  src={phoneIcon} alt="phone icon"/><span  style={{display:"inline-block", }}>+1 901-779-9013</span></p>
                        </div>
                        <div className="col-lg-4  col-md-4 col-sm-6">
                            <h4 className="label">العنوان</h4>
                            <p className="data md-txt"><img className="img-fluid" src={mapIcon} alt="maps icon"/>Jeddah Tower , Saudi Arabia , HI 96734</p>
                        </div>
                        <div className="col-lg-4  col-md-4 col-sm-6">
                        <h4 className="label">الايميل</h4>
                        <p className="data md-txt"><img className="img-fluid" src={mapIcon} alt="maps icon"/>info@cassandra.sa.com</p>
                    </div>
                    </div>
                </div>
                <div className="bottom-data">
                    <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <h4 className="label">الخدمات</h4>
                            <ul className="list-unstyled data-list">
                                <li><a className="data dark-white" href="/home">دراسة جدوى اولية</a></li>
                                <li><a className="data dark-white" href="/home">تحليل بيانات مشروعك</a></li>
                                <li><a className="data dark-white" href="/home">تحقيق أعلى ربح</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <h4 className="label">الدعم</h4>
                            <ul className="list-unstyled data-list">
                                <li><a className="data" href="/home">الأسئلة الشائعة </a></li>
                                <li><a className="data" href="/home">خدمة العملاء</a></li>
                                <li><a className="data" href="/home">تواصل معنا </a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <h4 className="label">الصفحات</h4>
                            <ul className="list-unstyled data-list">
                                <li><a className="data" href="/home">الأخبار</a></li>
                                <li><a className="data" href="/home">الأسعار</a></li>
                                <li><a className="data" href="/home">عن كساندرا</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <h4 className="label">المساعدة</h4>
                            <ul className="list-unstyled data-list">
                                <li><a className="data" href="/home">الشروط والأحكام</a></li>
                                <li><a className="data" href="/home">سياسة الخصوصية </a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                 {/*Social Links */}
            </div>
            <div className="footer-copyright-container">
                <div className="copyright">
                    <p>جميع الحقوق محفوظة | <span  style={{display:"inline-block", direction:"ltr", fontWeight:600, fontFamily:'Montserrat' }}>Crete Agency - 2021 </span></p>
                </div>
            </div>
        </div>
        
      </div>
    );
  };
  
  export default Footer;